/* ==========================================================================
   Wild Touch Engraving - storefront behaviour
   Loader, menu, cart, variants, personalization preview, forms.
   Everything here degrades: with JS off, forms post normally and links work.
   ========================================================================== */

(function () {
  'use strict';

  var routes = (window.WT && window.WT.routes) || {};

  function $(sel, scope) {
    return (scope || document).querySelector(sel);
  }
  function $$(sel, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(sel));
  }

  /* ------------------------------------------------------------- loader */
  /* Hard cap 1.6s, self-dismiss on load or 2.5s, once per session. */

  (function loader() {
    var el = $('[data-loader]');
    if (!el) return;

    if (sessionStorage.getItem('wt-loaded') || document.documentElement.getAttribute('data-motion-tier') === 'minimal') {
      el.remove();
      return;
    }

    var done = false;
    function dismiss() {
      if (done) return;
      done = true;
      sessionStorage.setItem('wt-loaded', '1');
      el.classList.add('is-lifting');
      setTimeout(function () {
        el.remove();
      }, 900);
    }

    setTimeout(dismiss, 1600);
    window.addEventListener('load', function () {
      setTimeout(dismiss, 200);
    });
    setTimeout(dismiss, 2500);
  })();

  /* --------------------------------------------------------- mobile menu */

  (function menu() {
    var panel = $('[data-menu-panel]');
    if (!panel) return;
    var lastFocus = null;

    function open(state) {
      panel.setAttribute('data-open', state ? 'true' : 'false');
      document.body.style.overflow = state ? 'hidden' : '';
      if (state) {
        lastFocus = document.activeElement;
        var first = panel.querySelector('a, button');
        if (first) first.focus();
      } else if (lastFocus) {
        lastFocus.focus();
      }
    }

    $$('[data-menu-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        open(true);
      });
    });
    $$('[data-menu-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        open(false);
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.getAttribute('data-open') === 'true') open(false);
    });
  })();

  /* ---------------------------------------------------------------- cart */

  function sparkBurst(x, y) {
    if (document.documentElement.getAttribute('data-motion-tier') === 'minimal') return;
    for (var i = 0; i < 4; i++) {
      var s = document.createElement('span');
      s.className = 'spark';
      s.style.left = x + 'px';
      s.style.top = y + 'px';
      s.style.setProperty('--sx', (Math.random() - 0.5) * 90 + 'px');
      s.style.setProperty('--sy', (Math.random() - 0.5) * 90 - 20 + 'px');
      document.body.appendChild(s);
      s.addEventListener('animationend', function () {
        this.remove();
      });
    }
  }

  function refreshCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count < 1;
    });
    var icon = $('[data-cart-icon]');
    if (icon) {
      icon.classList.remove('is-bumping');
      void icon.offsetWidth;
      icon.classList.add('is-bumping');
      var r = icon.getBoundingClientRect();
      sparkBurst(r.left + r.width / 2, r.top + r.height / 2);
    }
  }

  function addToCart(form, button) {
    var data = new FormData(form);
    var label = button ? button.innerHTML : '';

    if (button) {
      button.setAttribute('aria-disabled', 'true');
      button.textContent = '…';
    }

    return fetch(routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: data
    })
      .then(function (r) {
        return r.json().then(function (body) {
          if (!r.ok) throw new Error(body.description || body.message || 'Add to cart failed');
          return body;
        });
      })
      .then(function () {
        return fetch(routes.cart_url + '.js', { headers: { Accept: 'application/json' } }).then(function (r) {
          return r.json();
        });
      })
      .then(function (cart) {
        refreshCartCount(cart.item_count);
        if (button) {
          button.innerHTML = label;
          button.removeAttribute('aria-disabled');
        }
      })
      .catch(function (err) {
        if (button) {
          button.innerHTML = label;
          button.removeAttribute('aria-disabled');
        }
        var slot = form.querySelector('[data-cart-error]');
        if (slot) {
          slot.textContent = err.message;
          slot.hidden = false;
        } else {
          form.submit();
        }
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-cart-form]')) return;
    /* file uploads must post normally: Shopify handles the upload on POST */
    if (form.querySelector('input[type="file"][name^="properties"]')) return;
    e.preventDefault();
    addToCart(form, form.querySelector('[data-add-button]'));
  });

  /* ------------------------------------------------------------ quantity */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    if (!input) return;
    var step = btn.getAttribute('data-qty') === 'up' ? 1 : -1;
    var min = parseInt(input.min || '0', 10);
    input.value = Math.max(min, (parseInt(input.value, 10) || 0) + step);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ------------------------------------------------------------- variants */

  (function variants() {
    $$('[data-variant-picker]').forEach(function (picker) {
      var section = picker.closest('[data-product-root]');
      if (!section) return;
      var data = JSON.parse($('[data-variant-json]', section).textContent);

      picker.addEventListener('change', function () {
        var chosen = $$('input:checked', picker).map(function (i) {
          return i.value;
        });

        var match = data.filter(function (v) {
          return v.options.every(function (o, i) {
            return o === chosen[i];
          });
        })[0];

        var idInput = $('[data-variant-id]', section);
        var priceEl = $('[data-variant-price]', section);
        var addBtn = $('[data-add-button]', section);

        if (!match) {
          if (addBtn) {
            addBtn.setAttribute('aria-disabled', 'true');
            addBtn.textContent = window.WT.strings.unavailable;
          }
          return;
        }

        if (idInput) idInput.value = match.id;
        if (priceEl) {
          priceEl.innerHTML = match.price_html;
          priceEl.classList.remove('is-cut');
          void priceEl.offsetWidth;
          priceEl.classList.add('is-cut');
        }
        if (addBtn) {
          if (match.available) {
            addBtn.removeAttribute('aria-disabled');
            addBtn.textContent = addBtn.getAttribute('data-label');
          } else {
            addBtn.setAttribute('aria-disabled', 'true');
            addBtn.textContent = window.WT.strings.sold_out;
          }
        }

        if (match.featured_media_id) {
          var media = $('[data-media-id="' + match.featured_media_id + '"]', section);
          if (media) media.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
        }

        if (history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          history.replaceState({}, '', url);
        }
      });
    });
  })();

  /* ------------------------------------------------------- product thumbs */

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    var root = thumb.closest('[data-product-root]');
    var main = root && root.querySelector('.pdp__main img');
    if (!main) return;
    main.src = thumb.getAttribute('data-thumb');
    main.removeAttribute('srcset');
    $$('.thumb', root).forEach(function (t) {
      t.classList.toggle('is-active', t === thumb);
    });
  });

  /* --------------------------------------------- personalization preview */
  /* Renders the customer's engraving onto the product photo as they type.
     Debounced 250ms. This is the 2D fallback path described in the spec;
     it runs on every tier because it is the conversion moment. */

  (function personalization() {
    $$('[data-engrave-preview]').forEach(function (host) {
      var canvas = host.querySelector('canvas');
      var section = host.closest('[data-product-root]') || document;
      var input = $('[data-engrave-input]', section);
      var fontSelect = $('[data-engrave-font]', section);
      var counter = $('[data-engrave-counter]', section);
      if (!canvas || !input) return;

      var ctx = canvas.getContext('2d');
      var timer = null;

      function draw() {
        var w = (canvas.width = host.clientWidth * 2);
        var h = (canvas.height = host.clientHeight * 2);
        ctx.clearRect(0, 0, w, h);

        var text = input.value.trim();
        if (!text) return;

        var family = fontSelect ? fontSelect.value : 'var(--font-display)';
        var sizePx = Math.min(h * 0.16, (w * 1.5) / Math.max(text.length, 6));
        ctx.font = '600 ' + sizePx + 'px ' + family;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';

        /* engraved bevel: dark recess above, gold face, light catch below */
        ctx.fillStyle = 'rgba(10, 12, 31, 0.55)';
        ctx.fillText(text, w / 2, h / 2 - sizePx * 0.04);
        ctx.fillStyle = '#e8c77a';
        ctx.fillText(text, w / 2, h / 2);
        ctx.fillStyle = 'rgba(255, 255, 255, 0.35)';
        ctx.fillText(text, w / 2, h / 2 + sizePx * 0.03);
      }

      function schedule() {
        clearTimeout(timer);
        timer = setTimeout(draw, 250);
        if (counter) {
          var max = parseInt(input.getAttribute('maxlength') || '0', 10);
          counter.textContent = input.value.length + (max ? ' / ' + max : '');
          counter.classList.toggle('is-near-limit', max > 0 && input.value.length > max * 0.8);
        }
      }

      input.addEventListener('input', schedule);
      if (fontSelect) fontSelect.addEventListener('change', draw);
      window.addEventListener('resize', schedule, { passive: true });
      draw();
    });
  })();

  /* -------------------------------------------------------------- upload */

  $$('[data-upload-zone]').forEach(function (zone) {
    var input = zone.querySelector('input[type="file"]');
    var label = zone.querySelector('[data-upload-label]');
    if (!input) return;

    ['dragenter', 'dragover'].forEach(function (evt) {
      zone.addEventListener(evt, function (e) {
        e.preventDefault();
        zone.classList.add('is-active');
      });
    });
    ['dragleave', 'drop'].forEach(function (evt) {
      zone.addEventListener(evt, function (e) {
        e.preventDefault();
        zone.classList.remove('is-active');
      });
    });
    zone.addEventListener('drop', function (e) {
      if (e.dataTransfer.files.length) {
        input.files = e.dataTransfer.files;
        input.dispatchEvent(new Event('change'));
      }
    });
    input.addEventListener('change', function () {
      if (!input.files.length) return;
      if (label) label.textContent = input.files[0].name;
      var r = zone.getBoundingClientRect();
      sparkBurst(r.left + r.width / 2, r.top + r.height / 2);
    });
  });

  /* --------------------------------------------------------------- forms */
  /* Inline validation only. The browser still owns the constraint rules. */

  $$('form').forEach(function (form) {
    if (!form.querySelector('.field-error')) return;
    form.addEventListener(
      'invalid',
      function (e) {
        e.preventDefault();
        var field = e.target;
        var wrap = field.closest('.field') || field.parentElement;
        wrap.classList.add('is-invalid');
        var slot = wrap.querySelector('.field-error');
        if (slot) slot.textContent = field.validationMessage;
        if (!form.querySelector('.is-invalid input:focus, .is-invalid textarea:focus')) field.focus();
      },
      true
    );

    form.addEventListener('input', function (e) {
      var wrap = e.target.closest('.field');
      if (wrap && e.target.checkValidity()) {
        wrap.classList.remove('is-invalid');
        var slot = wrap.querySelector('.field-error');
        if (slot) slot.textContent = '';
      }
    });
  });

  /* ----------------------------------------------------- recommendations */

  $$('[data-recommendations]').forEach(function (host) {
    if (host.children.length) return;
    fetch(host.getAttribute('data-url'))
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = doc.querySelector('[data-recommendations] .grid');
        if (!grid) {
          host.closest('section').hidden = true;
          return;
        }
        host.appendChild(grid);
        if (window.WTMotion) window.WTMotion.scan(host);
      })
      .catch(function () {
        host.closest('section').hidden = true;
      });
  });

  /* -------------------------------------------------------- FAQ filtering */

  $$('[data-faq-search]').forEach(function (input) {
    var list = document.getElementById(input.getAttribute('data-faq-search'));
    if (!list) return;
    input.addEventListener('input', function () {
      var q = input.value.toLowerCase().trim();
      $$('[data-faq-item]', list).forEach(function (item) {
        var hit = !q || item.textContent.toLowerCase().indexOf(q) > -1;
        item.hidden = !hit;
      });
    });
  });

  /* ------------------------------------------------------------- lightbox */

  (function lightbox() {
    var box = $('[data-lightbox]');
    if (!box) return;
    var img = box.querySelector('img');

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-lightbox-open]');
      if (!trigger) return;
      e.preventDefault();
      img.src = trigger.getAttribute('data-lightbox-open');
      img.alt = trigger.getAttribute('data-lightbox-alt') || '';
      box.hidden = false;
      box.querySelector('button').focus();
    });

    box.addEventListener('click', function (e) {
      if (e.target === box || e.target.closest('[data-lightbox-close]')) box.hidden = true;
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') box.hidden = true;
    });
  })();
})();
